<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img"><img src="/assets/product/engine/4B15H/4B15H.jpg" alt=""></div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">4B15H 1.5L Hybrid Engine</div>
                <div class="detail-banner-desc">
                    A 1.5L naturally aspirated hybrid engine, matched with a DHT (Dedicated Hybrid Transmission), suitable for SUV and sedan models.<br />
                    Launch Date: 2023.
                </div>
                
            </div>
        </div>

        <div class="detail-swiper-list detail-box">
            <div class="img-box detail-swiper-right ">
                <img src="/assets/product/engine/4B15H/4B15H-1.jpg" alt=""></img>
            </div>
            <div class="detail-swiper-left">
                <div>
                    <div class="detail-title">
                        Powerful Performance
                    </div>
                    <div class="detail-desc">
                        The 1.5L naturally aspirated hybrid engine is paired with a DHT (Dedicated Hybrid Transmission) and is suitable for SUV and sedan models.<br />
                        Equipped with 350 bar high-pressure direct-injection (GDI) technology, fuel is injected directly into the cylinder for more homogeneous air-fuel mixture.Rapid combustion mitigates knock tendency under high load conditions and enhances engine power performance.
                    </div>
                </div>
                <div class="detail-swiper-utils">
                    <div class="detail-swiper-util-item">
                        <div class="detail-swiper-n">
                            85kW
                        </div>
                        <div class="detail-swiper-d">
                            Maximum power in 6000rpm
                        </div>
                    </div>
                    <div class="detail-swiper-util-item">
                        <div class="detail-swiper-n">
                            140N·m
                        </div>
                        <div class="detail-swiper-d">
                            Maximum torque (4000-4800)
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-swiper-list detail-box">
            <div class="img-box detail-swiper-right ">
                <img src="/assets/product/engine/4B15H/4B15H-2.jpg" alt=""></img>
            </div>
            <div class="detail-swiper-left">
                <div>
                    <div class="detail-title">
                        Low Fuel Consumption
                    </div>
                    <div class="detail-desc">
                        The high compression ratio combined with a high EGR (Exhaust Gas Recirculation) rate system helps mitigate engine knocking, allowing for increased ignition advance and reduced fuel consumption.<br />
                        The EGR system extracts gas before the catalytic converter, redirecting more combustible gases such as CO from the exhaust back into the combustion chamber for re-burning, further lowering fuel consumption.
                    </div>
                </div>
                <div class="detail-swiper-utils">
                    <div class="detail-swiper-util-item">
                        <div class="detail-swiper-n">
                            202g/kW·h
                        </div>
                        <div class="detail-swiper-d">
                            Minimum BSFC (Brake-Specific Fuel Consumption)
                        </div>
                    </div>
                    <div class="detail-swiper-util-item">
                        <div class="detail-swiper-n">
                            41.5%
                        </div>
                        <div class="detail-swiper-d">
                            Engine Thermal Efficiency
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-swiper-list detail-box">
            <div class="img-box detail-swiper-right ">
                <img src="/assets/product/engine/4B15H/4B15H-3.jpg" alt=""></img>
            </div>
            <div class="detail-swiper-left">
                <div>
                    <div class="detail-title">
                        Low Emissions
                    </div>
                    <div class="detail-desc">
                        The 350-bar direct injection system increases fuel injection pressure and optimizes mixture formation and combustion, effectively reducing harmful emissions such as unburned hydrocarbons (HC), carbon monoxide (CO), and nitrogen oxides (NOₓ) during cold starts or under high load.<br />
                        Integrating the exhaust manifold into the cylinder head improves engine warm-up speed, shortens catalyst light-off time, and reduces/improves emissions during cold starts.
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="detail-box">
        <div class="detail-title">Core Technologies</div>
        <!-- <div class="detail-desc"></div> -->

        <div class="detail-four-list">
            <div class="detail-four-item">
                <div class="img-box"><img src="/assets/product/engine/4B15H/4B15H-4.jpg" alt=""></div>
            </div>
            <div class="detail-four-item">
                <div class="detail-four-title">Wide Atkinson Cycle</div>
                <div class="detail-four-desc">
                    To balance power output and fuel economy, a large intake duration of 230° CA is adopted, together with VVT and a high stroke‑bore ratio of 1.28.<br />
                    The effective compression ratio can be adjusted between 16 and 10.9, which suppresses knock tendency, increases the expansion ratio, and thereby reduces fuel consumption.
                </div>
            </div>
            <div class="detail-four-item">
                <div class="detail-four-title">Electric Water Pump + Dual Thermostat Cooling Control System</div>
                <div class="detail-four-desc">
                    Based on vehicle operating conditions, different zones are defined according to knocking intensity.<br />
                    By precisely controlling the water pump flow rate and the opening/closing combination of thermostats, differentiated cooling strategies are applied to different zones. This not only suppresses knocking in high-load areas but also meets the coolant temperature requirements for fuel efficiency zones.
                </div>
            </div>
            <div class="detail-four-item">
                <div class="img-box"><img src="/assets/product/engine/4B15H/4B15H-5.jpg" alt=""></div>
            </div>
        </div>
    </div>

    <div class="detail-box">
        <div class="detail-swiper-list detail-box">
            <div class="img-box detail-swiper-right ">
                <img src="/assets/product/engine/4B15H/4B15H-6.jpg" alt=""></img>
            </div>
            <div class="detail-swiper-left">
                <div>
                    <div class="detail-title">
                        Swirl Intake Manifold
                    </div>
                    <div class="detail-desc">
                        The intake manifold features a swirl design. EGR (Exhaust Gas Recirculation) gases enter the intake manifold through tangential swirl channels and then flow into the stabilization chamber behind the throttle via non‑equal‑diameter outlets.<br />
                        High‑speed fresh air impacts and disperses the EGR gases, forming a homogeneous mixture that enters each cylinder. This improves EGR rate consistency across cylinders and enhances combustion stability.
                    </div>
                </div>
            </div>
        </div>
    </div>


    <Footer></Footer>
</template>

<script setup>
import { ref, nextTick, onMounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';

import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
const swiperInstances = ref({});

onMounted(() => {
    nextTick(() => {
        const swiperContainers = document.querySelectorAll('.swiper-container');

        swiperContainers.forEach((container, index) => {
            const containerKey = `swiper_${index}`;
            container.dataset.swiperKey = containerKey;
            const swiperInstance = new Swiper(container, {
                loop: false,
                slidesPerView: 1,
                spaceBetween: 0,
                speed: 300,
                preventClicks: true,
                effect: 'fade',
            });
            swiperInstances.value[containerKey] = swiperInstance;
        });

        bindTabClickEvent();
    });
});
function bindTabClickEvent() {
    const allSwiperLists = document.querySelectorAll('.detail-swiper-list');

    allSwiperLists.forEach((swiperList) => {
        const tabItems = swiperList.querySelectorAll('.detail-tab-item');
        const targetSwiperContainer = swiperList.querySelector('.swiper-container');

        if (!tabItems.length || !targetSwiperContainer) return;

        const containerKey = targetSwiperContainer.dataset.swiperKey;
        const targetSwiper = swiperInstances.value[containerKey];
        if (!targetSwiper) return;

        const handleTabAction = (tabItem, localTabIndex) => {
            tabItems.forEach(item => item.classList.remove('active'));
            tabItem.classList.add('active');
            targetSwiper.slideTo(localTabIndex, 300, true);
        };
        tabItems.forEach((tabItem, localTabIndex) => {
            const handleTabClickWrapper = () => {
                handleTabAction(tabItem, localTabIndex);
            };
            tabItem.removeEventListener('click', handleTabClickWrapper);
            tabItem.removeEventListener('mouseenter', handleTabClickWrapper);
            tabItem.addEventListener('click', handleTabClickWrapper);
            tabItem.addEventListener('mouseenter', handleTabClickWrapper);
        });
    });
}

</script>

<script>
export const pageConfig = {
  title: '4B15H 1.5L Hybrid Engine - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/engine/4B15H.html'
};

import { createApp } from 'vue';
import App from './4B15H.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"
import "@/assets/styles/product-details.scss"

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./4B15H.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>